/**
 * Created by yihong on 1/16/18.
 */

import {stringify} from 'query-string'
import axios from 'axios'

import {error_event} from '../tools/mgtv/analysis'


function checkResp(api_params) {
  try {
    const resp = api_params.resp;
    let url = api_params.url;
    if (!resp || !url) {
      return
    }
    url = url.replace(/^https?:/, "");
    url = url.split("?")[0]
    let error_msg = "";
    if (/vipact\d+.api.mgtv.com/.test(url)) {
      if (resp.ret < 0) {
        error_msg = url + ":" + resp.ret + ":" + resp.msg
      }
    } else if (/as.mgtv.com/.test(url)) {
      if (resp.status !== 200 && resp.status !== "200") { //有时是200 有的是"200"
        error_msg = url + ":" + resp.status + ":" + resp.msg

      }
    } else if (/nuc.api.mgtv.com/.test(url)) {
      if (resp.code !== 200 && resp.code !== "200") {
        error_msg = url + ":" + resp.code + ":" + resp.msg
      }
    } else if (/club.api.mgtv.com\/usercenter/.test(url)) { //主要是微信分享签名的接口
      if (resp.err !== 0 && resp.err !== "0") {
        error_msg = url + ":" + resp.code + ":" + resp.msg
      }
    }

    if (error_msg) {
      error_event(error_msg, {api: JSON.stringify(api_params)}, "api_ret")
    }
  } catch (e) {
    error_event(e, {api: JSON.stringify(api_params)}, "code_error")
  }
}

function checkApiError(e, api_params) {
  try {
    let url = api_params.url;
    if (!e || !url) {
      return
    }
    url = url.replace(/^https?:/, "");
    url = url.split("?")[0]
    if (e.message) {
      if (e.message.includes('timeout') || e.message.includes('timed out')) {
        error_event(url, {api: JSON.stringify(api_params)}, "api_timeout")
        return
      }
    } else if (e.message.includes('Request failed with status code')) {
      error_event(url, {api: JSON.stringify(api_params)}, "api_status")
      return
    }
    error_event(e, {api: JSON.stringify(api_params)}, "code_error")
  } catch (e) {
    error_event(e, {}, "code_error")
  }
}

const instant = axios.create();

export function getJSON(url, params = {}, timeout = 10000, withCredentials = false) {
  const api_params = {
    method: 'GET',
    url,
    params: JSON.stringify(params),
    timeout
  }
  return instant.get(url, {
    params: params,
    timeout: timeout,
    withCredentials
  }).then(r => {
    const resp = r.data;
    api_params.resp = resp;
    checkResp(api_params);
    return resp
  }).catch(e => {
    checkApiError(e, api_params)
    return null
  })
}


export function postJSON(url, params, data, timeout = 10000, withCredentials = false) {

  const api_params = {
    method: 'POST',
    url,
    params: JSON.stringify(params),
    data: JSON.stringify(data),
    timeout
  }

  let target_url = url;
  if (params) {
    if (url.includes('?')) {
      target_url = target_url + "&" + stringify(params)
    } else {
      target_url = target_url + "?" + stringify(params)
    }
  }
  return instant.post(target_url, data).then(r => {
    const resp = r.data;
    api_params.resp = resp;
    checkResp(api_params);
    return resp
  }).catch(e => {
    checkApiError(e, api_params)
    return null
  })
}

import fetchJsonp from 'fetch-jsonp'

export function getJSONP(url, params = {}, timeout = 10000) {
  let target_url = url;
  const api_params = {
    method: 'GET',
    url,
    params,
    timeout
  }
  if (params) {
    if (url.includes('?')) {
      target_url = target_url + "&" + stringify(params)
    } else {
      target_url = target_url + "?" + stringify(params)
    }
  }
  return fetchJsonp(target_url, {
    timeout: timeout
  }).then(r => {
    return r.json();
  }).then(resp => {
    api_params.resp = resp;
    checkResp(api_params)
    return resp;
  }).catch(e => {
    checkApiError(e, api_params)
    return null
  })
}



// WEBPACK FOOTER //
// ./src/api/myaxios.js